import styles from './MessagesList.module.css';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useMemo, useRef } from 'react';
import { motion } from 'motion/react';

import confetti from '../../assets/video/confetti.webm';

export const MessagesList = ({
  messages,
  authorFontSize,
  currentState,
  winId,
  speed,
  messagesRef,
}) => {
  const confettiRef = useRef(null);

  const isWinner = useMemo(
    () => currentState === 'S7' || currentState === 'S4',
    [currentState],
  );

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current && isWinner) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 1500);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [isWinner]);

  const letters = 'ПОБЕДИТЕЛЬ!'.split('').reverse();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={styles['wrapper']}
    >
      <div className={styles.firstLine} dir="rtl">
        {isWinner &&
          letters.map((l, idx, arr) => {
            let initialIdx = 3;
            let oneLetterWidth = 6;
            let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

            return (
              <motion.div
                style={{ position: 'relative', zIndex: idx * -1 }}
                key={l + idx}
                initial={{
                  scale: 0,
                  x: initialX,
                  // textShadow:
                  //   '0 0 2rem #00d8ff00, 0 0 2rem #00d8ff00, 0 0 2rem #00d8ff00',
                }}
                animate={{
                  scale: 1,
                  x: 0,
                  // textShadow:
                  //   '0 0 2rem #00d8ffff, 0 0 2rem #00d8ffff, 0 0 2rem #00d8ffff',
                }}
                // exit={{
                //   scale: 0,
                //   x: initialX,
                //   textShadow:
                //     '0 0 2rem #00d8ff00, 0 0 2rem #00d8ff00, 0 0 2rem #00d8ff00',
                //   transition: {
                //     delay: (arr.length - idx) * 0.15,
                //     duration: 0.7,
                //   },
                // }}
                transition={{
                  // textShadow: { duration: 0.6, delay: idx * 0.3 + 1 },
                  duration: 0.7,
                  delay: idx * 0.15 + 2,
                }}
              >
                {l}
              </motion.div>
            );
          })}
      </div>

      {currentState === 'S4' && messagesRef?.length === 1 ? (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
          style={{ marginTop: '10rem' }}
        >
          <Message
            message={messagesRef[0].message}
            authorFontSize={authorFontSize}
            currentState={currentState}
            winId={messagesRef[0].message?.id}
          />
        </motion.div>
      ) : (
        <div className={styles.messagesWrapper}>
          <TransitionGroup className={styles.messages}>
            {messages.length > 0 &&
              messages.map((item, i) => (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                >
                  <Message
                    winId={winId}
                    key={item.id}
                    message={item.message}
                    titrTag={item.titrTag}
                    authorFontSize={authorFontSize}
                    currentState={currentState}
                  />
                </CSSTransition>
              ))}
          </TransitionGroup>
        </div>
      )}

      {isWinner && (
        <video
          ref={confettiRef}
          muted="muted"
          loop
          playsInline
          className={styles.confetti}
        >
          <source src={confetti} type="video/webm"></source>
        </video>
      )}
    </motion.div>
  );
};
